import React, { useContext } from 'react';
import {
  Box,
  FloatingNotification as WSRFloatingNotification,
  FloatingNotificationType,
  SectionHelper,
} from '@wix/design-system';
import { StatusAlertFilled } from '@wix/wix-ui-icons-common';
import { observer } from 'mobx-react';
import { dataHooks } from '../../dataHooks';
import { NotificationStore } from '../../utils/notification';
import { AppContextProvider } from '../AppLoader';
import s from '../App/App.scss';

interface INotification {
  store?: NotificationStore;
}

export const FloatingNotification: React.FC<INotification> = observer(
  ({ store }) => {
    const {
      rootStore: {
        displayStore: { isMobile, errorToastIconColor },
      },
    } = useContext(AppContextProvider);

    if (!store?.isOpen) {
      return null;
    }

    if (store.theme === 'status-toast-error') {
      return (
        <Box
          className={s.sectionHelperError}
          dataHook={dataHooks.floatingNotification.main}
        >
          <SectionHelper
            appearance="danger"
            size={isMobile ? 'small' : 'medium'}
            fullWidth
            showPrefixIcon
            prefixIcon={
              <StatusAlertFilled style={{ color: errorToastIconColor }} />
            }
          >
            {store.content}
          </SectionHelper>
        </Box>
      );
    }

    return (
      <WSRFloatingNotification
        className={s.floatingNotification}
        dataHook={dataHooks.floatingNotification.main}
        type={store.theme as FloatingNotificationType}
        onClose={store.onClose}
        text={store.content}
        showCloseButton
      />
    );
  },
);
